import { Link } from 'react-router-dom';

export default function CTABanner() {
  return (
    <section className="relative w-full py-20 md:py-24 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20dreamy%20abstract%20gradient%20composition%20with%20flowing%20organic%20shapes%20in%20warm%20champagne%20cream%20and%20gentle%20sage%20green%20tones%20diffused%20ethereal%20light%20clean%20minimalist%20aesthetic%20calming%20peaceful%20atmosphere%20product%20showcase%20backdrop%20no%20text%20no%20sharp%20edges&width=1800&height=600&seq=cta-bg-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet CTA — najlepsze finds i okazje"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-background-50/70"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
          Gotowy na najlepsze <span className="text-accent-600">Kakobuy Finds</span>?
        </h2>
        <p className="font-body text-base text-foreground-600 mb-8 max-w-xl mx-auto">
          Nie trać czasu na przeszukiwanie — skorzystaj z gotowego Kakobuy Spreadsheet i znajdź najlepsze produkty w kilka sekund.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-label text-base font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
          <Link
            to="/artykul/kakobuy-spreadsheet-poradnik"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-transparent text-foreground-800 font-label text-base font-medium rounded-full border border-foreground-300/40 hover:border-foreground-300 hover:bg-background-50/50 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Przeczytaj poradnik
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}